define('views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'views/modules/calendar/animated-session/exercise/weight/weight-header',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-header.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent
    VWeightExerciseHeader,
    // templates
    TWeightBriefHeader
) {

    var VWeightBriefHeader = VWeightExerciseHeader.extend({
        template: TWeightBriefHeader,
    });

    return VWeightBriefHeader;

});

